import { requestGet, requestPost, requestFormPost } from '@/common/request';

// 根据条件分页查询商品效果数据 https://cf.jd.com/pages/viewpage.action?pageId=789896439
export const getInviteInfo = async (query) => {
  return await requestFormPost('/generic/mac/activityMaterial/get', query);
};

// 日常活动规则邀约-完善素材列表 https://cf.jd.com/pages/viewpage.action?pageId=794740477
export const getInviteMaterialList = async (param) => {
  return await requestGet('/generic/mac/activity/querySkuMaterialsRuleInvitation', param);
};
